import { render } from "./DocumentDemo.vue?vue&type=template&id=1ef81490&scoped=true"
import script from "./DocumentDemo.vue?vue&type=script&lang=js"
export * from "./DocumentDemo.vue?vue&type=script&lang=js"

import "./DocumentDemo.vue?vue&type=style&index=0&id=1ef81490&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef81490"]])

export default __exports__